<div
  class="feature-tile flex flex-col justify-center items-center"
  [class.dynamic-height]="isDynamicHeight"
  [class.fill-height]="isFullHeight"
  [class.error]="error"
>
  <ng-container *ngIf="!isNgContent">
    <div
      data-at-value
      class="feature-value"
      ViEllipsis
      [includeHeight]="true"
      [showTextContentInTooltip]="true"
    >
      <span *ngIf="value !== undefined">{{ value }}</span>
      <img *ngIf="assetSource" [src]="assetSource" />
    </div>
    <div
      data-at-description
      class="feature-description"
      ViEllipsis
      [includeHeight]="true"
      [showTextContentInTooltip]="true"
    >
      <span *ngIf="description !== undefined">{{ description }}</span>
    </div>
    <div
      class="feature-label"
      [class.feature-label-optional-flex]="
        informationTooltip && label?.length < optimalCharacterCountWhereEllipsisIsNotNeeded
      "
      ViEllipsis
      [includeHeight]="true"
      [showTextContentInTooltip]="true"
    >
      <span [ngStyle]="preLabelStyles" *ngIf="preLabel" class="pre-label"> {{ preLabel }}</span>
      {{ label }}
      <mat-icon
        *ngIf="informationTooltip && showInformationTooltip"
        [matTooltip]="informationTooltip"
        matTooltipClass="multiline-tooltip"
      >
        info_outline
      </mat-icon>
    </div>
    <mat-icon *ngIf="error" class="error-icon">{{ iconVariant }}</mat-icon>
  </ng-container>
  <ng-content></ng-content>
</div>
